export function getMicrosoftProduct(url: string): string {
	if (url.includes('sharepoint.com')) return 'sharepoint';
	if (url.includes('powerbi.com')) return 'power-bi';
	if (url.includes('teams.microsoft.com')) return 'teams';
	return 'Microsoft';
}
